import axios from '@/lib/axios'
import { buildAdminRequestConfig, type OrganizationId } from '@/lib/organization-scoping'
import type { ProductCatalogPrintHtml, ProductCatalogPrintInput } from './productCatalogPrint.types'

export interface ProductCatalogPrintScope {
  organizationId: OrganizationId
  values: ProductCatalogPrintInput
}

export function printProductCatalog({
  organizationId,
  values,
}: ProductCatalogPrintScope): Promise<ProductCatalogPrintHtml> {
  return axios.post<ProductCatalogPrintHtml>(
    '/products/catalog/print',
    values,
    buildAdminRequestConfig({ organizationId })
  )
}
